<span title="{{ title }}" class="sm {{ classNames }} search-category">{{
  title
    | dotdotdot : smCharacterLength || characterLength || defaultCharacterLength
}}</span>

<span title="{{ title }}" class="md {{ classNames }} search-category">{{
  title
    | dotdotdot : mdCharacterLength || characterLength || defaultCharacterLength
}}</span>
<span
  title="{{ title }}"
  class="lg {{ classNames }} search-category"
  data-test-id="responsive-title-lg"
  >{{
    title
      | dotdotdot
        : lgCharacterLength || characterLength || defaultCharacterLength
  }}</span
>
